import { InviteCodePanel } from '../components/InviteCodePanel';
import { ManagementPageLayout } from '../components/management/ManagementPageLayout';
import { useAuth } from '../hooks/useAuth';
import { canAccessAdminPages } from '../utils/roleUtils';

export const InviteManagementPage = () => {
  const [authState] = useAuth();

  return (
    <ManagementPageLayout
      authState={authState}
      canAccess={canAccessAdminPages}
      maxWidthClassName="max-w-4xl"
    >
      <div className="space-y-2">
        <InviteCodePanel />
      </div>
    </ManagementPageLayout>
  );
};
